<template>
  <div class="stat-filter--first-row">
    <v-select
        v-for="filter in localFilters"
        v-model="selected[filter.id]"
        :key="filter.id"
        :clearable="false"
        :reduce="(option) => option.value"
        :create-option="option => ({ label: option, value: option })"
        :options="filter.items"
        @input="(option) => updateSelect(filter.id, option)"
        push-tags
        :taggable="filter.id === 'user' || filter.id === 'site'"
        label="label">
    </v-select>
  </div>
</template>
<script>

export default {
  name: 'RowFilters',
  props: {
    filters: {},
  },
  data: function() {
    return {
      localFilters: [],
      selected: {},
    };
  },
  methods: {
    updateSelect(filterId, option) {
      this.selected[filterId] = option;
      this.localFilters = [...this.localFilters];
      this.$emit('change', this.selected);
    },
    setDefaultSelected(filters) {
      filters.forEach(filter => {
        this.selected[filter.id] = filter.defaultValue;
      });
    },
  },
  watch: {
    filters: {
      immediate: true,
      handler(val) {
        const setDefault = this.localFilters.length === 0;
        this.localFilters = val;
        if (setDefault) {
          this.setDefaultSelected(val);
        }
      },
    },
  },
};
</script>
